import {Button, Col, Container, Form, FormControl, Row, Spinner} from "react-bootstrap";
import {useEffect, useState} from "react";
import {assignJobWorker, getAllJobCount, getAllJobsString, toDateString} from "../service/JobService";
import JobStatusToggleGroup from "./JobStatusToggleGroup";
import {getFieldWorkers, getSuperVisor} from "../service/UserService";
import JobCardList from "./JobCardList";
import ActiveWorkerToggleGroup from "./ActiveWorkerToggleGroup";

function stringToDate(dateString) {
    let parts = dateString.split('-');
    let mydate = new Date(parts[0], parts[1] - 1, parts[2]);
    return mydate
}


export default function Scheduler() {
    const now = new Date();
    const [isLoading, setIsLoading] = useState(false)
    const [tableData, setTableData] = useState([])

    const [leftBorderHighlight, setLeftBorderHighlight] = useState(false)
    const [rightBorderHighlight, setRightBorderHighlight] = useState(false)

    const [fieldWorkerMap, setFieldWorkerMap] = useState({})
    const [fieldWorkerArray, setfieldWorkerArray] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [fieldSupervisorMap, setFieldSupervisorMap] = useState({})
    const [fieldSupervisorArray, setfieldSupervisorArray] = useState([])


    const [radioValue, setRadioValue] = useState(() => {
        const radioValue = localStorage.getItem('radioValue');
        return radioValue ? radioValue : "Pending";
    });

    const [statusCounts, setStatusCounts] = useState({})
    const [workerCounts, setWorkerCounts] = useState({})

    const [selectedDate, setSelectedDate] = useState(() => {
        const schedulerDate = localStorage.getItem('schedulerDate');
        return schedulerDate ? schedulerDate : toDateString(now);
    });

    const [searchText, setSearchText] = useState(() => {
        const searchText = localStorage.getItem('searchText');
        return searchText ? searchText : "";
    });
    const scheduler1 = "3";
    const [activeWorkerId, setActiveWorkerId] = useState(scheduler1)

    function refreshJobList(currentSelectionDate) {
        setIsLoading(true)
        getAllJobsString(currentSelectionDate, currentSelectionDate).then(response => {
            if (response.status === 200) {

                response.json().then(result => {
                    const counts = {};
                    const workerCounts = {}
                    for (const job of result) {
                        counts[job.status] = counts[job.status] ? counts[job.status] + 1 : 1;
                        if (job.status === "Cancelled") {
                            continue
                        }
                        workerCounts[job.cos_job_worker] = workerCounts[job.cos_job_worker] ? workerCounts[job.cos_job_worker] + 1 : 1;
                    }
                    let cosJobIdList = result.map(job => job.cos_job_id)
                    getAllJobCount(cosJobIdList).then(countResponse => {
                        let tempJobCount = {}
                        if (countResponse.status === 200) {
                            countResponse.json().then(countResult => {
                                countResult.map(count => {
                                    tempJobCount[count.cos_job_id] = count
                                })
                                result.map(job => {
                                    job.notes_count = tempJobCount[job.cos_job_id] ? tempJobCount[job.cos_job_id].notes_count : 0
                                    job.images_count = tempJobCount[job.cos_job_id] ? tempJobCount[job.cos_job_id].images_count : 0
                                    job.req_fix_count = tempJobCount[job.cos_job_id] ? tempJobCount[job.cos_job_id].req_fix_count : 0
                                    job.req_deep_clean_count = tempJobCount[job.cos_job_id] ? tempJobCount[job.cos_job_id].req_deep_clean_count : 0
                                    job.req_key_count = tempJobCount[job.cos_job_id] ? tempJobCount[job.cos_job_id].req_key_count : 0
                                })
                                setStatusCounts(counts)
                                setWorkerCounts(workerCounts)
                                filterTables(result, radioValue, searchText)
                            })
                        } else {
                            countResponse.text().then(result => console.log(result))
                        }
                    })

                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error))
            .finally(() => {
                setIsLoading(false)
            });
    }

    function refreshFieldWorkers() {
        getFieldWorkers().then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    setfieldWorkerArray(result);
                    let tmpFieldWorkerMap = {};
                    result.map(obj => {
                        tmpFieldWorkerMap[obj.id] = obj.name
                    })
                    setFieldWorkerMap(tmpFieldWorkerMap)
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error));
    }

    function refreshSupervisors() {
        getSuperVisor().then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    setfieldSupervisorArray(result);
                    let tmpFieldSupervisorMap = {};
                    result.map(obj => {
                        tmpFieldSupervisorMap[obj.id] = obj.name
                    })
                    setFieldSupervisorMap(tmpFieldSupervisorMap)
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error));
    }

    useEffect(() => {
        console.log("useEffect Render in Scheduler")
        refreshFieldWorkers();
        refreshSupervisors()
        refreshJobList(selectedDate);
    }, []);

    function handleSelect(eventDate) {
        setSelectedDate(eventDate.target.value);
        localStorage.setItem('schedulerDate', eventDate.target.value);
        refreshJobList(eventDate.target.value);
    }

    function filterTables(rawdata, radioValue, searchText) {
        let tempData = rawdata
        if (radioValue !== 'ALL') {
            tempData = rawdata.filter(item => item.status && item.status.includes(radioValue),);
        }
        //cos_customer_name, username, agent_name, phone, email
        if (searchText && searchText.length > 0) {
            tempData = tempData.filter(item => (item.full_address && item.full_address.toLowerCase().includes(searchText.toLowerCase()) || (item.agent_name && item.agent_name.toLowerCase().includes(searchText.toLowerCase())) || (item.cos_customer_name && item.cos_customer_name.toLowerCase().includes(searchText.toLowerCase())) || (item.phone && item.phone.toLowerCase().includes(searchText.toLowerCase())) || (item.email && item.email.toLowerCase().includes(searchText.toLowerCase())) || (item.cos_job_id && item.cos_job_id.toLowerCase().includes(searchText.toLowerCase())) || (item.cos_job_worker && fieldWorkerMap[item.cos_job_worker] && fieldWorkerMap[item.cos_job_worker].toLowerCase().includes(searchText.toLowerCase()))));
        }
        // Sort by B2B_NEW tags first, then by full_address alphabetically
        tempData = tempData.slice().sort((a, b) => {
            // Check for B2B_NEW tags first
            const aHasB2BNew = a.tags && a.tags.includes("B2B_NEW");
            const bHasB2BNew = b.tags && b.tags.includes("B2B_NEW");
            
            // If one has B2B_NEW and the other doesn't, prioritize the one with B2B_NEW
            if (aHasB2BNew && !bHasB2BNew) return -1;
            if (!aHasB2BNew && bHasB2BNew) return 1;
            
            // If both have or don't have B2B_NEW, sort by full_address alphabetically
            if (!a.full_address) return 1;
            if (!b.full_address) return -1;
            return a.full_address.localeCompare(b.full_address);
        });
        setTableData(rawdata)
        setFilteredData(tempData)
    }


    function toggleRoleFilter(value) {
        setRadioValue(value)
        localStorage.setItem('radioValue', value);
        filterTables(tableData, value, searchText)
    }

    function filterSearchText(value) {
        setSearchText(value)
        localStorage.setItem('searchText', value);
        // setRoleFilterSelection
        filterTables(tableData, radioValue, value)

    }

    function delta(x) {
        let d = new Date()
        if (x !== 0) {
            d = stringToDate(selectedDate)
            d.setDate(d.getDate() + x);
        }
        setSelectedDate(toDateString(d))
        localStorage.setItem('schedulerDate', toDateString(d));
        refreshJobList(toDateString(d))

    }


    function handleDrop(ev, workerId) {
        ev.preventDefault();
        let data = ev.dataTransfer.getData('cos_job_id');
        assignJobWorker(data, workerId).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    refreshJobList(selectedDate);
                })
            } else {
                response.text().then(result => {
                        // setResponseMessage(result);
                        refreshJobList(selectedDate);
                    }
                )

            }
        }).catch(error => console.log('error', error));
    }

    function handleAssignDrop(ev) {
        setIsLoading(true)
        handleDrop(ev, activeWorkerId)
        setRightBorderHighlight(false)
        setLeftBorderHighlight(false)
    }

    function handleRevertDrop(ev) {
        //Hard code back to 3 as //Pending Status
        setIsLoading(true)
        handleDrop(ev, 3)
        setRightBorderHighlight(false)
        setLeftBorderHighlight(false)
    }

    function getWorkerFilter() {
        // Filter and then sort by B2B_NEW tags first, then by full_address alphabetically
        return tableData
            .filter(job => job.cos_job_worker === (activeWorkerId + "") && job.status !== "Cancelled")
            .slice()
            .sort((a, b) => {
                // Check for B2B_NEW tags first
                const aHasB2BNew = a.tags && a.tags.includes("B2B_NEW");
                const bHasB2BNew = b.tags && b.tags.includes("B2B_NEW");
                
                // If one has B2B_NEW and the other doesn't, prioritize the one with B2B_NEW
                if (aHasB2BNew && !bHasB2BNew) return -1;
                if (!aHasB2BNew && bHasB2BNew) return 1;
                
                // If both have or don't have B2B_NEW, sort by full_address alphabetically
                if (!a.full_address) return 1;
                if (!b.full_address) return -1;
                return a.full_address.localeCompare(b.full_address);
            });
    }

    return (<Container fluid>
            <Row className="mb-2">
                <Col sm={6} style={{textAlign: "left"}}>
                    <JobStatusToggleGroup
                        radioValue={radioValue}
                        setRadioValue={toggleRoleFilter}
                        statusCounts={statusCounts}/>
                </Col>
                <Col sm={3}>
                    <div style={{display: "flex"}}>
                        <Button
                            disabled={isLoading}
                            variant="outline-secondary" onClick={() => {
                            delta(-1)
                        }}>{'<'}</Button>
                        <Form.Control
                            disabled={isLoading}
                            style={{width: "150px", marginLeft: "10px", marginRight: "10px"}}
                            type="date" name='date'
                            onChange={handleSelect}
                            value={selectedDate}/>
                        <Button
                            disabled={isLoading}
                            variant="outline-secondary" onClick={() => {
                            delta(1)
                        }}>{'>'}</Button>
                        <Button
                            style={{marginLeft: "10px"}}
                            disabled={isLoading}
                            variant="outline-secondary" onClick={() => {
                            delta(0)
                        }}>{'Today'}</Button>

                    </div>

                </Col>
                <Col sm={1}><Button style={{width: "80px"}} variant="secondary" disabled={isLoading}
                                    onClick={() => refreshJobList(selectedDate)}>
                    {isLoading ? <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    /> : "Refresh"}


                </Button></Col>
                <Col sm={2} style={{textAlign: "right"}}>

                    <FormControl
                        disabled={isLoading}
                        value={searchText}
                        onChange={(e) => filterSearchText(e.target.value)}
                        type="search"
                        placeholder="Enter Filter Text..."
                        className="mr-2"
                        aria-label="Search"
                    />
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col onDragOver={(e) => {
                    e.preventDefault()
                    setLeftBorderHighlight(true)
                    setRightBorderHighlight(false)
                }}
                     onDrop={handleRevertDrop}
                     style={{
                         height: Math.max(tableData.length, getWorkerFilter().length) * 420,
                         border: leftBorderHighlight ? '3px dashed darkBlue' : '3px dashed transparent'

                     }}
                >

                    {filteredData.length > 0 ? filteredData.map((job, idx) => (<JobCardList
                        job={job}
                        key={idx}
                        fieldSupervisorMap={fieldSupervisorMap}
                        fieldWorkerMap={fieldWorkerMap}
                        isLoading={isLoading}

                    />)) : <div style={{
                        height: "200px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                            <span>No Job available on Current Date and Filter <br/>
                            <a href="#" onClick={() => {
                                filterSearchText("")
                            }}>Try Clear Filter</a></span>
                    </div>}
                </Col>
                <Col onDragOver={(e) => {
                    e.preventDefault()
                    setRightBorderHighlight(true)
                    setLeftBorderHighlight(false)
                }}
                     onDrop={handleAssignDrop}
                     style={{
                         height: Math.max(tableData.length, getWorkerFilter().length) * 420,
                         border: rightBorderHighlight ? '3px dashed darkBlue' : '3px dashed transparent'
                     }}
                >
                    <Row><Col sm={12}><ActiveWorkerToggleGroup
                        activeWorkerId={activeWorkerId}
                        setActiveWorkerId={setActiveWorkerId}
                        workerStatusCount={workerCounts}
                        fieldWorkerMap={fieldWorkerMap}
                        fieldWorkerArray={fieldWorkerArray}/></Col></Row>
                    {getWorkerFilter()
                        .map((job, idx) => (<JobCardList
                            job={job}
                            key={idx}
                            fieldSupervisorMap={fieldSupervisorMap}
                            fieldWorkerMap={fieldWorkerMap}/>))}

                </Col>

            </Row>


        </Container>


    );
}
